let React = require('react');
let Input = require('./../../../input');

class URLsForm extends React.Component {

  change (key, event) {
    this.props.onChange(key, event.target.value);
  }

  greeting () {
    if (this.props.has_status_page === 'customer') {
      if (this.props.loggedIn) {
        return <p>Since you're logged in, we were able to pull the following information from your Statuspage account.  Verify that this is correct and proceed to the next step.</p>;
      } 
        return <p>If you <a href="https://manage.statuspage.io/login">login</a>, we can pull this information in automatically.  No worries, though, if you don't want to.</p>;
      
    } else  {
      return <p>We're making good progress! Now we need some info about your website and support channels.</p>;
    }
  }

  minimumFields () {
    return (
      <div>
        <Input
label="Homepage URL"
          name="homepage_url"
          defaultValue={this.props.homepage_url}
          onChange={this.change.bind(this, 'homepage_url')}  />
        <Input
label="Support Email Address or URL"
          name="support_email_address"
          defaultValue={this.props.support_email_address}
          onChange={this.change.bind(this, 'support_email_address')}  />
      </div>
    );
  }

  requiredInputs () {
    if (this.props.has_status_page === 'customer' || this.props.has_status_page === 'non-customer') {
      return (
        <div className="urls-form">
          <Input
label="Statuspage URL"
            name="status_page_url"
            defaultValue={this.props.status_page_url}
            onChange={this.change.bind(this, 'status_page_url')}  />
          {this.minimumFields()}
        </div>
      );
    } else if (this.props.has_status_page === 'no') {
      return (
        <div className="urls-form">
          {this.minimumFields()}
        </div>
      );
    }
  }

  render () {
    return (

      <div>
        <div className="step-container step-two">
          <h2>Awesome!</h2>
          {this.greeting()}
          {this.requiredInputs()}
          <small>
            We'll use this information to add helpful links to your error pages.
          </small>
        </div>
      </div>
    );
  }

}

module.exports = URLsForm;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/better_error_pages/walk_through/questions/urls_form.jsx